/**
 * The clipboard across the person's tabs and windows (`tab-clipboard.ts`): product settings, not per environment.
 */
export const clipboardConfig = {
  /**
   * The largest copy shared with the person's other tabs and kept for a reload, in bytes of its share form: the client
   * core's `clipboardShareBytes` (`worker/config.ts`). A larger copy pastes only in the tab that made it, and its
   * command line says so. 16 MiB holds a whole floor plan of several thousand objects.
   */
  shareMaxBytes: 16 * 1024 * 1024,
  /** The BroadcastChannel every tab of the origin hears copies and clears on. */
  channel: "orthos.draft.clipboard",
  /** The IndexedDB database and store keeping each person's latest copy, for a reload and for tabs opened later. */
  database: "orthos.clipboard",
  databaseVersion: 1,
  store: "copies",
  /** Most characters of text from another app that Ctrl+V pastes as MTEXT; longer text is cut there. */
  maxPastedTextChars: 20_000,
} as const;
